import Swal from 'sweetalert2'

export default {
    name: 'EditUser',    
    created() {
        this.GetOffices();
        this.UserType = [
            {
                id: 1,
                name: "ادارة متابعة المكاتب"
            },
            {
                id: 2,
                name: 'موظفين متابعة المكاتب'
            },
            {
                id: 4,
                name: 'مدير مكتب العمل'
            },
            {
                id: 3,
                name: 'موظف مكتب العمل'
            },
        ];

        this.form.FullName = this.$parent.EditUsersObj.name;
        this.form.UserName = this.$parent.EditUsersObj.loginName;
        this.form.PhoneNumber = this.$parent.EditUsersObj.phone;
        this.form.Email = this.$parent.EditUsersObj.email;
        this.form.MunicipalityId = this.$parent.EditUsersObj.municipalityId;
        this.form.DateOfBirth = this.$parent.EditUsersObj.birthDate;
        this.form.UserId = this.$parent.EditUsersObj.userId;
        this.form.UserType = this.$parent.EditUsersObj.userType;
        this.form.Address = this.$parent.EditUsersObj.address;
        this.form.OfficeId = this.$parent.EditUsersObj.officeId;
        this. getMunicipalities();

    },
    data() {
       
        return {
            CurrentUserType: this.$parent.loginDetails.userType,
            UserType: [],
            Municipalities: [],
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Offices: [],
            isFromSelect: true,
            Users: [],
            state: 0,
            form: {
                UserName: '',
                Address: '',
                Password: null,
                FullName: '',
                UserType: '',
                Email: '',
                UserId: null,
                OfficeId: null,
                MunicipalityId: null,
                PhoneNumber: '',
                DateOfBirth: '',
                Status: 0,             
               
            },
            ConfimPassword: '',

            gender:[],
        
        };
    },
    methods: {
        GetOffices() {
            this.$blockUI.Start();
            this.$http.GetOffice().then(response => {
                this.$blockUI.Stop();
                this.Offices = response.data.offices;
            })
                .catch(error => {
                    this.$blockUI.Stop();
                    Swal.fire(error.response.data, 'error')
                })
        },

        Back() {
            this.$parent.state = 0;
        },
       
        validPhoneNumber: function (PhoneNumber) {

            var mobileRegex = /^09[1|2|3|4|5][0-9]{7}$/i;

            return mobileRegex.test(PhoneNumber);
        },

        validEmail: function (email) {
            var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validUserName: function (UserName) {
            var login = /^[a-zA-Z]{0,40}$/;
            return login.test(UserName);
        },
        validFullName: function (FullName) {
            var loginArabic = /^[\u0621-\u064A\u0660-\u0669 ]+$/;
            return loginArabic.test(FullName);
        },
        Edit(){

            if (!this.form.Email) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء إدخال البريد الإلكتروني '
                });
                return;
            } else if (!this.validEmail(this.form.Email)) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء إدخال البريد الإلكتروني بطريقه صحيحه '
                });
                return;
            }

            if (!this.form.DateOfBirth) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء إختيار تاريخ الميلاد '
                });
                return;
            }


            if (!this.form.PhoneNumber) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء رقم الهاتف '
                });
                return;
            } else if (!this.validPhoneNumber(this.form.PhoneNumber)) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء إدخال رقم الهاتف  بطريقه صحيحه '
                });
                return;
            }
            this.form.MunicipalityId = parseInt(this.form.MunicipalityId);
            this.form.OfficeId = parseInt(this.form.OfficeId);
           
            this.$http.EditUser(this.form)
                .then(response => {        
                    this.$message({
                        type: 'info',
                        message: response.data
                    });
                    this.$parent.EditUsersObj = [];
                    this.$parent.OfficeId = "";
                    this.$parent.getUser(this.pageNo);
                  this.$parent.state = 0;
                 
                })
                .catch((err) => {
                    this.$message({
                        type: 'error',
                        message: err.response.data
                    });
                });
        },
        getMunicipalities() {
            
            this.$blockUI.Start();
            this.$http.GetMunicipalitieOffies(this.form.OfficeId).then(response => {
                this.$blockUI.Stop();
                this.Municipalities = response.data;
                this.form.MunicipalityId = this.Municipalities[0].id;

            })
                .catch(error => {
                    this.$blockUI.Stop();
                    Swal.fire(error.response.data, 'error')
                })
        },
    }    
}